import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer.jsx";
import Header from "../components/Header.jsx";
import { useTracking } from "../utils/useTracking.js";

export default function RootLayout() {
	useTracking();

	return (
		<div className='root-layout'>
			<Header />

			<main>
				<Outlet />
			</main>

			<Footer />
		</div>
	);
}
